export default (val: number): string => {
  return val.toString().length > 4
    ? val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
    : val.toString();
};
